import React from "react";

function AlertIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      imageRendering="optimizeQuality"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      viewBox="0 0 512 463.43"
      width={20}
      height={20}
      {...props}
    >
      {/* <path
        fillRule="evenodd"
        fill={"red"}
        d="M2.347 9.633h38.297V3.76A3.77 3.77 0 0 1 44.404 0h21.144a3.77 3.77 0 0 1 3.76 3.76v5.874h37.83a2.353 2.353 0 0 1 2.347 2.349v11.514H0V11.982a2.354 2.354 0 0 1 2.347-2.349zM8.69 29.605h92.921c1.937 0 3.696 1.599 3.521 3.524l-7.864 86.229c-.174 1.926-1.59 3.521-3.523 3.521h-77.3c-1.934 0-3.352-1.592-3.524-3.521L5.166 33.129c-.172-1.932 1.585-3.524 3.524-3.524zm60.387 13.393h9.866v65.314h-9.866V42.998zm-39.005 0h9.867v65.314h-9.867V42.998zm19.5 0h9.869v65.314h-9.869V42.998z"
        clipRule="evenodd"
      /> */}
      <path d="M189.46 44.02c34.26-58.66 99.16-58.77 133.24.12l.97 1.81 175.27 304.4c33.71 56.4-1.2 113.76-66.17 112.96v.12H73.53c-.9 0-1.78-.04-2.66-.11-58.34-.79-86.64-54.22-61.9-106.84.39-.85.82-1.67 1.28-2.46l-.04-.03 179.3-309.94-.05-.03zm50.32 302.4c4.26-4.13 9.35-6.19 14.45-6.56 3.4-.24 6.8.29 9.94 1.48 3.13 1.19 6.01 3.03 8.39 5.41 6.92 6.91 8.72 17.38 4.64 26.16-2.69 5.8-7.08 9.7-12.11 11.78-3.03 1.27-6.3 1.84-9.56 1.76-3.27-.08-6.49-.82-9.41-2.18-5.02-2.33-9.3-6.43-11.7-12.2-2.65-6.36-2.27-12.96.63-19.15 1.15-2.46 2.75-4.81 4.73-6.5zm33.86-47.07c-.8 19.91-34.51 19.93-35.28-.01-3.41-34.1-12.13-110.53-11.85-142.58.28-9.87 8.47-15.72 18.94-17.95 3.23-.69 6.78-1.03 10.35-1.02 3.6.01 7.16.36 10.39 1.05 10.82 2.3 19.31 8.39 19.31 18.45l-.05 1-11.81 141.06z" />
    </svg>
  );
}

export default AlertIcon;
